export default __webpack_public_path__ + "static/media/mpLayersIcon_new.c694bfa7.svg";